.fieldError {
  display: flex;
  align-items: center;
  gap: var(--ism-spacing-2xs);
  margin-top: var(--ism-spacing-2xs);
  color: var(--ism-color-primary);
  font-family: inherit;
  font-size: var(--ism-font-size-body-s);
}
